export default function SlashIcon({ className }: { className?: string }) {
  return (
    <span className="text-(--ds-gray-500)">
      <svg
        data-testid="geist-icon"
        height="16"
        stroke-linejoin="round"
        viewBox="0 0 16 16"
        width="16"
        className="text-gray-500"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.01526 15.3939L4.3107 14.7046L10.3107 0.704556L10.6061 0.0151978L11.9849 0.606077L11.6894 1.29544L5.68942 15.2954L5.39398 15.9848L4.01526 15.3939Z"
          fill="currentColor"
        ></path>
      </svg>
    </span>
  )
}
